import PropTypes from 'prop-types';
import { useMutation } from '@apollo/client';
import LoginViaFacebookMutation from './LoginViaFacebookMutation';

const LoginViaFacebookConnectorApollo = ({ children }) => {
  const [mutate, { loading }] = useMutation(LoginViaFacebookMutation);

  const createLogin = async (token) => {
    const response = await mutate({
      variables: {
        token,
      },
    });

    return response;
  };

  return children({
    loginViaFacebook: createLogin,
    loading,
  });
};

LoginViaFacebookConnectorApollo.propTypes = {
  children: PropTypes.func.isRequired,
};

export default LoginViaFacebookConnectorApollo;
